// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"535":"9b97b303","646":"9b97b303","940":"f133882c"}[chunkId] + ".css";
};